import { render, staticRenderFns } from "./ComparteGana.vue?vue&type=template&id=7c9b8e75&scoped=true"
import script from "./ComparteGana.vue?vue&type=script&lang=js"
export * from "./ComparteGana.vue?vue&type=script&lang=js"
import style0 from "./ComparteGana.vue?vue&type=style&index=0&id=7c9b8e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9b8e75",
  null
  
)

export default component.exports